import React from 'react';

interface YesOrNoSelectorProps {
  label: string;
  value: boolean;
  onChange: (value: boolean) => void;
}

const YesOrNoSelector: React.FC<YesOrNoSelectorProps> = ({
  label,
  value,
  onChange
}) => {

  const handleChange = (newValue: boolean) => {
    onChange(newValue);
  };

  return (
    <div className="field-group">
      <div className="form-group input-container-wrapper">
        <label>{label}:</label>
        <div className="input-container">
          <div className="btn-group">
            <button type='button'
              className={`btn btn-primary ${value === true ? 'active' : ''}`}
              onClick={() => handleChange(true)}
            >
              Yes
            </button>
            <button type='button'
              className={`btn btn-primary ${value === false ? 'active' : ''}`}
              onClick={() => handleChange(false)}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default YesOrNoSelector;